module.exports = __webpack_public_path__ + "static/media/student4.13532ce5.png";